module.exports = __webpack_public_path__ + "static/ali-close-baf50a642cd3b7af926e6096c5ceb5a2.jpg";